import { GetProjectTypes, GetProjectTypesToken } from "$src/application/customers/queries/GetProjectTypes";
import { ProjectType } from "$src/domain/customers/ProjectType";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function fetchProjectTypes(groupStoreId: number): Promise<ProjectType[]> {
   
    const query = container.resolve<GetProjectTypes>(GetProjectTypesToken);
    return query.execute(groupStoreId);
}

export function useProjectTypes(groupStoreId: number) {

    return useQuery<ProjectType[], Error>({
        queryKey: ['project-types', groupStoreId],
        queryFn: () => fetchProjectTypes(groupStoreId),
        staleTime: 600000,
        cacheTime: 1200000,
    });
}
